import React, { Component }  from 'react';
import Modal from '../../../components/Modal';
import { connect } from 'react-redux';
import { fetchGrabarHistorialFDV } from '../../../actions';
import { fetchDesasignarPedidos }  from '../../../utils/DesasignacionPedido';
import  getTipoDesasignacion     from '../../../utils/getTipoDesasignacion';
import { FadeLoader } from 'react-spinners';
import _ from 'lodash';

const estadoTramaInactivo = '0';

class DesasignarPedido extends Component {

  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      muestraLoad:'none',
      listaMotivos:[],
      tipoMotivo:'',
      observacion:'',
      estadoPedido:[],
      estadoPedidoArrayUnicos:[]

    };
  }
  componentDidMount() {

      this.loadPage();

  }

  loadPage=()=>{

    getTipoDesasignacion(this.props.proforma.codAreaVta).then((results) =>{
       this.setState({listaMotivos:results.data.listaArchivos})
      }
    )

    let estadoPedido = [];
    let estadoPedidoArrayUnicos = [];

    estadoPedido = _.filter(this.props.pedidosXfichaVenta, _.property(this.props.proforma.numProfVeh))[0][this.props.proforma.numProfVeh];
    estadoPedidoArrayUnicos = estadoPedido.filter(entry => this.props.pedidosEquiposAdicionales.indexOf(entry.numPedidoVeh)>=0);
    estadoPedidoArrayUnicos = [...new Set(estadoPedidoArrayUnicos.map(entry => {return entry.estadoPedido}))];

    if(estadoPedidoArrayUnicos.length>1){
        this.props.closeModal();
        this.props.openAlert({
          estadoTrama:estadoTramaInactivo,
          mensaje:'Para realizar la desasignacion, los pedidos deben tener el mismo estado.'
        })
    }

    this.setState({
      estadoPedido:estadoPedido,
      estadoPedidoArrayUnicos:estadoPedidoArrayUnicos
    });


  }

  fnDesasignarPedidos(){

    this.setState({muestraLoad:'block'});

          const promises = [];
          this.props.pedidosEquiposAdicionales.forEach(pedido => {
              promises.push(
                        fetchDesasignarPedidos(
                            this.props.proforma.numFichaVtaVeh,
                            pedido,
                            this.props.nurPedidos.filter(entry => entry.numPedidoVeh===pedido)!==undefined?this.props.nurPedidos.filter(entry => entry.numPedidoVeh===pedido)[0].codCIA:'',
                            this.props.nurPedidos.filter(entry => entry.numPedidoVeh===pedido)!==undefined?this.props.nurPedidos.filter(entry => entry.numPedidoVeh===pedido)[0].codProv:'',
                            this.props.nurPedidos.filter(entry => entry.numPedidoVeh===pedido)!==undefined?this.props.nurPedidos.filter(entry => entry.numPedidoVeh===pedido)[0].nurFichaVtaPedido:'',
                            this.state.tipoMotivo,
                            this.state.observacion,
                            this.state.listaMotivos.filter((item)=>item.codigo === this.state.tipoMotivo).length>0?this.state.listaMotivos.filter((item)=>item.codigo === this.state.tipoMotivo)[0].descripcion:'',
                            this.state.estadoPedido.filter(entry => entry.estadoPedido==='PREASIGNADO' && entry.numPedidoVeh===pedido).length>0?1:0
                          ),
                      )})

          Promise.all(promises).then((results) => {
                // this.props.loadProformas(this.props.proforma.numFichaVtaVeh);
                 this.props.fnLimpiarPedidosConCheck();
                 this.props.traerFacturacion(this.props.proforma.numFichaVtaVeh);
                 this.props.fnVaciarPedidosConCheck();
                 this.props.openAlert(results[0].data);


            }).then(() =>
            {
              this.props.fnUnSelectedAll();
              this.props.closeModal();
            }).catch((error) => {
                  this.props.openAlert({estadoTrama:estadoTramaInactivo,mensaje:'No se Ejecuto Correctamente'})
            });
            this.setState({muestraLoad:'none'});

  }

  onChangeAndFilter = (e) =>{
    this.setState({tipoMotivo: e.target.value});
  }
  onChangeValue = (e) =>{
    this.setState({observacion: e.target.value});
  }

  render() {

    return(
    <div>
        <Modal title='Confirmar' idModal='desasignar-pedido' isOpen closeModal={this.props.closeModal} modalSize='modal-dialog'>
        <p className='h6 text-center'>¿Está seguro que deseas desasignar el/los pedido/s ?</p>
        {this.props.pedidosEquiposAdicionales.map((pedido,id) =>
          <p key={id} className='h6 text-center'>{pedido}</p>
        )}

        {this.state.estadoPedidoArrayUnicos[0]==='PREASIGNADO'?(
          <div>
          <label className='labelInfo' htmlFor='sucursalDespacho'>Motivo de Desasignacion</label>

            <div className='select'>
              <select className='form-control' id='tipoMotivo' onChange={this.onChangeAndFilter} name='tipoMotivo' value={this.state.tipoMotivo}>
                <option value=''>Selecciona una motivo</option>
                {
                  this.state.listaMotivos.map(motivo =>
                    <option
                      key={motivo.codigo}
                      value={motivo.codigo}
                    >
                      {motivo.descripcion}
                    </option>
                  )
                }
              </select>
              <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
            </div>
          </div>
          ):null}

          <div className='form-group comment-textarea'>
                  <div className='form-group'>
                    <label htmlFor='observacion'>Observación</label>
                    <textarea
                      className='form-control'
                      name='observacion'
                      value={this.state.observacion}
                      onChange={this.onChangeValue}
                      maxLength='2000'
                    />
                  </div>
          </div>

        <div className='modal-actions'>
          <button className='btn btn-default' data-dismiss='modal' onClick={this.props.closeModal}>Volver</button>
          <button className='btn btn-primary pull-right' data-dismiss='modal'  disabled={ this.state.estadoPedidoArrayUnicos[0]==='ASIGNADO'?false:!(this.state.tipoMotivo.length>0)} onClick ={()=>this.fnDesasignarPedidos()}>desasignar</button>
        </div>
      </Modal>
      <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
        <div className='modal-dialog modal-sm' role='document'>
          <FadeLoader color={'#F8A14A'} loading />
        </div>
      </div>
    </div>
  )


  }

}
function mapStateToProps(state) {
  return {
  };
}

export default connect(
  mapStateToProps,
  { fetchGrabarHistorialFDV }

)(DesasignarPedido);



// WEBPACK FOOTER //
// ./src/pages/modals/DesasignarPedido/index.js